import service from '@/utils/server';

const modName = '/mdlzsct/planAppointment/';
//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//明细
export const detail = data => {
  return service({
    url: modName + 'detail/' + data,
    method: 'post',
  });
};



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/planAppointmentLog/api/index.js